var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptySearchMsg = function SvgImgEmptySearchMsg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.222 19.889)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M66.204 17.063H13V8.531A8.532 8.532 0 0 1 21.531 0h44.673a8.531 8.531 0 0 1 8.531 8.531 8.531 8.531 0 0 1-8.53 8.532z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.679,
    cy: 13.156,
    r: 4.179,
    fill: "#BDBDBD",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 13,
    r: 4,
    fill: "#EBEBEB",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 37,
    r: 4,
    fill: "#EBEBEB",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M43.571 41.063H13V32.53c0-4.71 3.82-8.53 8.531-8.53h22.04a8.532 8.532 0 1 1 0 17.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M24.006 8a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm-9 24a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm10-24a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm11 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptySearchMsg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-search-msg.188475934b2b925ead63e2e2638968fc.svg";